import { useEffect, 
    useRef, 
    useState 
} from 'react';
// import { Html5Qrcode } from 'html5-qrcode';
import { Html5QrcodeScanner } from 'html5-qrcode';

const Html5Scanner = () => {
  const [result, setResult] = useState('No barcode detected');
  // const [ scanResult, setScanResult] = useState(null);
    const [data, setData] = useState([]);
  // const scannerRef = useRef(null);
  const  scanRef = useRef(null);
  const [pause, setPause] = useState(false);

  const beepSound = new Audio('/beep.mp3');

  useEffect(() => {
        // const html5QrCode = new Html5Qrcode(scannerRef.current.id);
        // const scanner = new Html5QrcodeScanner('reader', {
            // qrbox: {
        //         width: 250,
        //         height: 250,
        //     },
        //     fps: 5,
        // });

        // scanner.render(success, error);

        // function success(result) {
        //     scanner.clear();
        //     setScanResult(result);
        // }

        // function onError(err) {
        //     console.warn(err);
            
        // }
       
        function onScanSuccess(decodedText, decodedResult) {
          beepSound.play();
          setResult(decodedText);
            // if (decodedText !== lastResult) 
            if (decodedText !== scanRef.current)
            {
                // lastResult = decodedText;
                scanRef.current = decodedText;
                setData({...data, decodedResult});
                // Handle on success condition with the decoded message.
                console.log(`Scan result ${decodedText}`, decodedResult);
            }
            // html5QrcodeScanner.clear();
            // html5QrcodeScanner.pause(true);
            setPause(true);
            // html5QrcodeScanner.resume();
        }

        var html5QrcodeScanner = new Html5QrcodeScanner(
            "qr-reader", { 
              fps: 5, 
              qrbox: {
                width: 250,
                height: 250,
              },
            });

        html5QrcodeScanner.render(onScanSuccess);


    // const startScanning = async () => {
    //   try {
    //     await html5QrCode.start(
    //       // { facingMode: 'environment' }, // Use the rear camera
    //       { fps: 5, qrbox: { width: 250, height: 250 } },
    //       (decodedText) => setResult(decodedText),
    //       (error) => console.warn(error)
    //     );
    //   } catch (err) {
    //     console.error('Error starting scanner', err);
    //   }
    // };

    // startScanning();

    // return () => {
    //   html5QrCode.stop().then(() => html5QrCode.clear());
    // };
  }, []);

  // const state = html5QrcodeScanner.getState();
  // console.log(state);
  // if(!pause && state===3) {
  //   html5QrcodeScanner.resume();
  // }


  // console.log(data);
  return (
    <div className="flex flex-col w-full max-w-lg p-4  mx-auto justify-center items-center">
      <h1>Barcode Scanner</h1>
      {/* {scanResult 
      ? <div> Success: <a href="/">{scanResult}</a></div>
      : <div id="reader"></div>
      }
      <div id="scanner" ref={scannerRef} style={{ width: '250px', height: '250px' }} /> */}
      <p>{result}</p>  

       <div id="qr-reader" style={{width:'500px'}}></div> 
      {/* <div id="qr-reader-results"></div> */}

     {data &&  (
        <div>
            <p>text: {data.decodedResult?.decodedText}</p>
            <p>formatName: {data.decodedResult?.result?.format.formatName}</p>
            <p>format: {data.decodedResult?.result?.format.format}</p>
            {/* <p>text: {data.decodedResult?.result.text}</p> */}
            <hr />
            {/* {pause && (
              <button onClick={() => setPause(false)}>Resume Scan.</button>

            )} */}
        </div>
      )}


      <a href="/" className="text-sm italic text-blue-700 rounded-full p-1 hover:text-blue-400 hover:bg-blue-600">Home...</a>
    </div>
  );
};

export default Html5Scanner;
